import { Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import Icon from "../../Icon"
import DigitalAlertsSection from "./components/DigitalAlertsSection"
import DigitalCard from "./components/DigitalCard"
import { statisticData } from "./constants"

import "./styles.less"

const { Text } = Typography

function DigitalReceiptPage() {
  const isMobile = useSelector((state) => state.nav.isMobile)
  const theme = useSelector((state) => state.nav.theme)
  const isAdmin = useSelector((state) => state.auth.isAdmin)
  const { t } = useTranslation()

  return (
    <Flex className="digital-receipt-page" gap={24} vertical>
      <Flex gap={24} className="digital-cards-row">
        {statisticData.map((item, index) => (
          <DigitalCard
            key={item.id}
            data={item}
            isActive={index === 0}
            onClick={() => {}}
            isAdmin={isAdmin}
            theme={theme}
          />
        ))}
      </Flex>

      <div className="digital-alerts-wrapper">
        <DigitalAlertsSection />

        <div className="digital-receipt-overlay">
          <div className="digital-receipt-content">
            <div className="digital-receipt-icon">
              <Icon className="lock-icon" type="lock_blue" />
            </div>

            <h2 className="digital-receipt-title">{t("Digital Receipt is almost here")}</h2>

            <Text type="secondary" className="digital-receipt-description">
              {t(
                "When a bank inquires about a charge, Digital Receipt returns instant proof of purchase, so the cardholder recognizes it and no dispute is opened."
              )}
            </Text>

            <button type="button" className="digital-receipt-button">
              Coming soon...
            </button>
          </div>
        </div>
      </div>
    </Flex>
  )
}

export default DigitalReceiptPage
